const ApiBaseUrl = {
    apiBaseUrl: process.env.REACT_APP_API_BASE_URL || 'https://restaurantapi.themetasum.com/api',
};
export default ApiBaseUrl;
